import React from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { FaExclamationTriangle, FaClock, FaHourglassHalf, FaChartLine } from 'react-icons/fa';
import { getRotacionBadge } from '../../utils/LabelColors';
import FormattedDate from '../../utils/DateFormat';

const ICON_BY_ESTADO = {
    liquidacion: { Icon: FaExclamationTriangle, color: 'text-red-600 hover:text-red-800' },
    sin_ventas: { Icon: FaClock, color: 'text-amber-500 hover:text-amber-700' },
    lento: { Icon: FaHourglassHalf, color: 'text-orange-500 hover:text-orange-700' },
    alta_rotacion: { Icon: FaChartLine, color: 'text-emerald-600 hover:text-emerald-800' },
};

const buildTooltipContent = (estadoRotacion, meta, badge) => {
    let text = badge?.tooltip || badge?.label || estadoRotacion;
    if (estadoRotacion === 'liquidacion') {
        text = `${badge?.label}\nPriorizar venta; no volver a pedir. Se desactiva al agotarse.`;
    } else if (estadoRotacion === 'lento' && meta?.fechaUltimaVenta) {
        text = `${badge?.label}\nÚltima venta: ${FormattedDate(meta.fechaUltimaVenta)}`;
    } else if (estadoRotacion === 'alta_rotacion' && meta?.ventas30 != null) {
        text = `${badge?.label}\n${meta.ventas30} ventas en los últimos 30 días.`;
    } else if (estadoRotacion === 'sin_ventas') {
        text = `${badge?.label}\nProducto reciente sin ventas registradas.`;
    }
    return text;
};

/**
 * Ícono discreto de rotación (solo empleados). Tooltip al hover.
 */
const RotacionBadge = ({ estadoRotacion, ventas30, fechaUltimaVenta, tooltipId }) => {
    if (!estadoRotacion || estadoRotacion === 'normal') return null;

    const badge = getRotacionBadge(estadoRotacion);
    if (!badge) return null;

    const iconCfg = ICON_BY_ESTADO[estadoRotacion] || ICON_BY_ESTADO.lento;
    const { Icon, color } = iconCfg;
    const id = tooltipId || `rotacion-${estadoRotacion}-${Math.random().toString(36).slice(2, 9)}`;
    const content = buildTooltipContent(estadoRotacion, { ventas30, fechaUltimaVenta }, badge);

    return (
        <>
            <span
                className="inline-flex items-center"
                data-tooltip-id={id}
                data-tooltip-content={content}
            >
                <Icon className={`h-6 w-6 ${color}`} aria-label={badge.label} />
            </span>
            <Tooltip
                id={id}
                place="top"
                style={{
                    maxWidth: '280px',
                    whiteSpace: 'pre-line',
                    zIndex: 9999,
                    fontSize: '13px',
                }}
            />
        </>
    );
};

export default RotacionBadge;
